module.exports = __webpack_public_path__ + "static/media/wechat.b3439ad1.jpg";